<script lang="ts">
  import ModalShell from './ModalShell.svelte';

  let {
    title,
    message,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    destructive = false,
    onConfirm,
    onCancel,
  }: {
    title: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
    destructive?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
  } = $props();

  let confirmEl: HTMLButtonElement | null = $state(null);

  $effect(() => {
    confirmEl?.focus();
  });
</script>

<ModalShell {title} onClose={onCancel} role="alertdialog">
  <p class="message">{message}</p>
  <div class="actions">
    <button class="btn btn-secondary" type="button" onclick={onCancel}>{cancelLabel}</button>
    <button
      bind:this={confirmEl}
      class="btn"
      class:btn-primary={!destructive}
      class:btn-destructive={destructive}
      type="button"
      onclick={onConfirm}
    >{confirmLabel}</button>
  </div>
</ModalShell>

<style>
  .message {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
    color: var(--color-body);
  }
  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    margin-top: 0.25rem;
  }
  .btn-destructive {
    background: var(--color-error);
    color: var(--color-on-dark);
    border-radius: var(--radius-sm);
    padding: 13px 22px;
    min-height: 48px;
  }
  .btn-destructive:hover { background: color-mix(in srgb, var(--color-error) 85%, black); }
</style>
